/* eslint-disable import/prefer-default-export */
import { call } from 'redux-saga/effects';

import {
  fetchInvoicesElectricityRequest,
  fetchInvoicesWaterRequest,
  fetchInvoicesGasRequest,
} from '../requests';

export function* fetchInvoicesElectricityService(currentMonth) {
  yield call(fetchInvoicesElectricityRequest, currentMonth);
}

export function* fetchInvoicesWaterService(currentMonth) {
  yield call(fetchInvoicesWaterRequest, currentMonth);
}

export function* fetchInvoicesElectricityGasService(currentMonth) {
  yield call(fetchInvoicesGasRequest, currentMonth);
}
